import type { BrowserHistory } from '@remix-run/router';
import { PropsWithChildren, useState, useRef, useLayoutEffect } from 'react';
import { Router } from 'react-router-dom';

import { createHistory } from '~/util/history/routerHistory';

export interface BrowserRouterPreserveParamsProps {
  preserve: string[];
  basename?: string;
  window?: Window;
}

export const BrowserRouterPreserveParams = ({
  children,
  basename,
  preserve,
  window,
}: PropsWithChildren<BrowserRouterPreserveParamsProps>) => {
  const historyRef = useRef<BrowserHistory>(undefined);
  if (historyRef.current === undefined) {
    historyRef.current = createHistory({ window, preserve, v5Compat: true });
  }

  const history = historyRef.current;
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router basename={basename} location={state.location} navigationType={state.action} navigator={history}>
      {children}
    </Router>
  );
};
